"use client"

import { Layout } from "antd"
import { BasicProps } from "antd/es/layout/layout"
import { FC, RefAttributes } from "react"

const LayoutContent: FC<BasicProps & RefAttributes<HTMLElement>> = (props) => {
  return (
    <Layout.Content {...props} />
  )
}

export default LayoutContent